import React, { Component } from 'react';
import './App.css';
import Tone from 'tone';
import P5Wrapper from 'react-p5-wrapper';

const chorus = new Tone.Chorus(5, 0.5, 5).toMaster();
const crusher = new Tone.BitCrusher(8).toMaster();
const reverb = new Tone.Freeverb(0.5,3000).toMaster();
const feedbackDelay = new Tone.FeedbackDelay(1.6, 0.8).toMaster();
const crusher2 = new Tone.BitCrusher(8).toMaster();
const reverb2 = new Tone.Freeverb(0.5, 3000).toMaster();

const seventeen = new Tone.Player({
  "url": "new_samps/172021.mp3",
  "mute": false,
  "loop": true,
  "loopStart": 0.0,
  "loopEnd": 51.2,
  "volume": 0
}).connect(chorus).toMaster();

const eighteen = new Tone.Player({
  "url": "new_samps/182021.mp3",
  "mute": false,
  "loop": true,
  "loopStart": 0.0,
  "loopEnd": 51.2,
  "volume": 0
}).connect(crusher).toMaster();

const nineteen = new Tone.Player({
  "url": "new_samps/192021.mp3",
  "mute": false,
  "loop": true,
  "loopStart": 0.0,
  "loopEnd": 51.2,
  "volume": 0
}).connect(reverb).toMaster();

const twenty = new Tone.Player({
  "url": "new_samps/202021.mp3",
  "mute": false,
  "loop": true,
  "loopStart": 0.0,
  "loopEnd": 51.2,
  "volume": 0
}).connect(feedbackDelay).toMaster();

const twentyone = new Tone.Player({
  "url": "new_samps/212021.mp3",
  "mute": false,
  "loop": true,
  "loopStart": 0.0,
  "loopEnd": 51.2,
  "volume": 0
}).connect(crusher2).toMaster();

const twentytwo = new Tone.Player({
  "url": "new_samps/222021.mp3",
  "mute": false,
  "loop": true,
  "loopStart": 0.0,
  "loopEnd": 51.2,
  "volume": 0
}).connect(reverb2).toMaster();

class App extends Component {
  render() {
    return (
      <div className="App" id="App">
        <div className="content">
          <div className="sketch">
            <P5Wrapper sketch={sketch} />
          </div>
        </div>
      </div>
    );
  }
}

function sketch(p) {

  var imgs = [];

  var trigger = false;
  var mobileTrigger = false;

  var nX = p.windowWidth / 10;
  var nY = p.windowHeight / 6;

  var n2X = p.windowWidth / 10;
  var n2Y = (p.windowHeight / 6) + (p.windowHeight / 9);

  var n3X = p.windowWidth / 10;
  var n3Y = (p.windowHeight / 6) + ((p.windowHeight / 9)*2);

  var n4X = p.windowWidth / 10;
  var n4Y = (p.windowHeight/ 6) + ((p.windowHeight / 9)*3);

  var n5X = p.windowWidth / 10;
  var n5Y = (p.windowHeight / 6) + ((p.windowHeight / 9)*4);

  var n6X = p.windowWidth / 10;
  var n6Y = (p.windowHeight / 6) + ((p.windowHeight / 9)*5);

  var exitX = p.windowWidth / 2 - 18.125;
  var exitY = p.windowHeight - p.windowHeight / 5;

  p.preload = function preload() {
    imgs.push(
      p.loadImage("new_img/17.png"),
      p.loadImage("exit.png"),
      p.loadImage("new_img/18.png"),
      p.loadImage("new_img/19.png"),
      p.loadImage("new_img/20.png"),
      p.loadImage("new_img/21.png"),
      p.loadImage("new_img/22.png")
    );
  }

  p.setup = function () {
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.frameRate(60);
  }

  Tone.Buffer.on('load', function () {

    p.draw = function () {

      p.clear();
      p.image(imgs[0], nX, nY, 45, 37.75);
      p.image(imgs[1], exitX, exitY, 36.25, 17.5);
      p.image(imgs[2], n2X, n2Y, 45, 37.75);
      p.image(imgs[3], n3X, n3Y, 45, 37.75);
      p.image(imgs[4], n4X, n4Y, 60.75, 37.75);
      p.image(imgs[5], n5X, n5Y, 45, 37.75);
      p.image(imgs[6], n6X, n6Y, 60.75, 37.75);

      if (nX === n2X && nY === n2Y) {
        nX = nX - 50;
        n2X = n2X + 50;
      };

      if (nX === n3X && nY === n3Y) {
        nX = nX - 50;
        n3X = n3X + 50;
      };

      if (nX === n4X && nY === n4Y) {
        nX = nX - 50;
        n4X = n4X + 50;
      };

      if (nX === n5X && nY === n5Y) {
        nX = nX - 50;
        n5X = n5X + 50;
      }

      if (nX === n6X && nY === n6Y) {
        nX = nX - 50;
        n6X = n6X + 50;
      }

      if (n2X === n3X && n2Y === n3Y) {
        n2X = n2X - 50;
        n3X = n3X + 50;
      };

      if (n2X === n4X && n2Y === n4Y) {
        n2X = n2X - 50;
        n4X = n4X + 50;
      };

      if (n2X === n5X && n2Y === n5Y) {
        n2X = n2X - 50;
        n5X = n5X + 50;
      }

      if (n2X === n6X && n2Y === n6Y) {
        n2X = n2X - 50;
        n6X = n6X + 50;
      }

      if (n3X === n4X && n3Y === n4Y) {
        n3X = n3X - 50;
        n4X = n4X + 50;
      }

      if (n3X === n5X && n3Y === n5Y) {
        n3X = n3X - 50;
        n5X = n5X + 50;
      }

      if (n3X === n6X && n3Y === n6Y) {
        n3X = n3X - 50;
        n6X = n6X + 50;
      }

      if (n4X === n5X && n4Y === n5Y) {
        n4X = n4X - 50;
        n5X = n5X + 50;
      }

      if (n4X === n6X && n4Y === n6Y) {
        n4X = n4X - 50;
        n6X = n6X + 50;
      }

      if (n5X === n6X && n5Y === n6Y) {
        n5X = n5X - 50;
        n6X = n6X + 50;
      }

      seventeen.volume.value = nX / (p.windowWidth / 75) - 45;
      chorus.depth = nY / (p.windowHeight / 10);
      eighteen.volume.value = n2X / (p.windowWidth / 75) - 45;
      crusher.bits = (n2Y / (p.windowHeight / 10)) + 8;
      nineteen.volume.value = n3X / (p.windowWidth / 75) - 45;
      reverb.roomSize.value = (n3Y / (p.windowHeight / 10) * 0.1);
      twenty.volume.value = n4X / (p.windowWidth / 75) - 45;
      feedbackDelay.feedback.value = n4Y / (p.windowHeight / 10) * 0.1;
      twentyone.volume.value = n5X / (p.windowWidth / 75) - 45;
      crusher2.bits = (n5Y / (p.windowHeight / 10)) + 4;
      twentytwo.volume.value = n6X / (p.windowWidth / 75) - 45;
      reverb2.roomSize.value = (n6Y / (p.windowHeight / 10) * 0.1);
      //console.log((n3Y / (p.windowHeight/10)) * 0.1);
      //console.log(n4Y);
      //console.log(n2X / (p.windowWidth / 75) - 75);

      if (p.mouseX > exitX
        && p.mouseX < exitX + 36.25
        && p.mouseY > exitY
        && p.mouseY < exitY + 17.5) {
        p.cursor(p.HAND);
      }
      else {
        p.cursor(p.ARROW);
      }

      if (p.mouseX > nX 
        && p.mouseX < nX + 45
        && p.mouseY > nY 
        && p.mouseY < nY + 37.75) {
        p.cursor(p.MOVE);
      }

      if (p.mouseX > n2X 
        && p.mouseX < n2X + 45
        && p.mouseY > n2Y 
        && p.mouseY < n2Y + 37.75) {
        p.cursor(p.MOVE);
      }

      if (p.mouseX > n3X
      && p.mouseX < n3X + 45
      && p.mouseY > n3Y
      && p.mouseY < n3Y + 37.75) {
        p.cursor(p.MOVE);
      }

      if (p.mouseX > n4X
      && p.mouseX < n4X + 60.75
      && p.mouseY > n4Y
      && p.mouseY < n4Y + 37.75) {
        p.cursor(p.MOVE);
      }

      if (p.mouseX > n5X
      && p.mouseX < n5X + 45
      && p.mouseY > n5Y
      && p.mouseY < n5Y + 37.75) {
        p.cursor(p.MOVE);
      }

      if (p.mouseX > n6X
      && p.mouseX < n6X + 60.75
      && p.mouseY > n6Y
      && p.mouseY < n6Y + 37.75) {
        p.cursor(p.MOVE);
      }

      p.mousePressed = function mousePressed() {
          if (trigger === false) {
          seventeen.start();
          eighteen.start();
          nineteen.start();
          twenty.start();
          twentyone.start();
          twentytwo.start();
          trigger = true;
          mobileTrigger = true;
          }

        if (p.mouseX > exitX
          && p.mouseX < exitX + 36.25
          && p.mouseY > exitY
          && p.mouseY < exitY + 17.5) {
          window.location = "../";
        }
      }

      p.mouseDragged = function mouseDragged() {
        if (trigger === false) {
          seventeen.start();
          eighteen.start();
          nineteen.start();
          twenty.start();
          twentyone.start();
          twentytwo.start();
          trigger = true;
        }
        if (p.mouseX > nX && p.mouseX < nX + 45
          && p.mouseY > nY && p.mouseY < nY + 37.75) {
          nX = p.mouseX - 22.5;
          nY = p.mouseY - 18.875;
          //console.log(nX / (p.windowWidth / 75) - 55);
        }
        if (p.mouseX > n2X && p.mouseX < n2X + 45
          && p.mouseY > n2Y && p.mouseY < n2Y + 37.75) {
          n2X = p.mouseX - 22.5;
          n2Y = p.mouseY - 18.875;
          //console.log(n2X / (p.windowWidth / 75) - 55); 
        }
        if (p.mouseX > n3X && p.mouseX < n3X + 45
          && p.mouseY > n3Y && p.mouseY < n3Y + 37.75) {
          n3X = p.mouseX - 22.5;
          n3Y = p.mouseY - 18.875;
          //console.log((n3Y / (p.windowHeight / 10) * 0.1));
          //console.log(reverb.wet.value)
        }

        if (p.mouseX > n4X && p.mouseX < n4X + 60.75
          && p.mouseY > n4Y && p.mouseY < n4Y + 37.75) {
          n4X = p.mouseX - 30.375;
          n4Y = p.mouseY - 18.875;
          //console.log((n3Y / (p.windowHeight / 10) * 0.1));
          //console.log(feedbackDelay.feedback.value);
          //try again
        }
        if (p.mouseX > n5X && p.mouseX < n5X + 45
          && p.mouseY > n5Y && p.mouseY < n5Y + 37.75) {
          n5X = p.mouseX - 22.5;
          n5Y = p.mouseY - 18.875;
      }

        if (p.mouseX > n6X && p.mouseX < n6X + 60.75
          && p.mouseY > n6Y && p.mouseY < n6Y + 37.75) {
          n6X = p.mouseX - 30.375;
          n6Y = p.mouseY - 18.875;
          }

      p.touchStarted = function touchStarted() {
        if (mobileTrigger === false) {
          seventeen.start();
          eighteen.start();
          nineteen.start();
          twenty.start();
          twentyone.start();
          twentytwo.start();
          mobileTrigger = true;
        }
        
        if (p.mouseX > exitX
          && p.mouseX < exitX + 36.25
          && p.mouseY > exitY
          && p.mouseY < exitY + 17.5) {
          window.location = "../";
        }
      }

      p.touchMoved = function touchMoved() {
        if (p.mouseX > nX && p.mouseX < nX + 45
          && p.mouseY > nY && p.mouseY < nY + 37.75) {
          nX = p.mouseX - 22.5;
          nY = p.mouseY - 18.875;
        }
        if (p.mouseX > n2X && p.mouseX < n2X + 45
          && p.mouseY > n2Y && p.mouseY < n2Y + 37.75) {
          n2X = p.mouseX - 22.5;
          n2Y = p.mouseY - 18.875;
        }
        if (p.mouseX > n3X && p.mouseX < n3X + 45
          && p.mouseY > n3Y && p.mouseY < n3Y + 37.75) {
          n3X = p.mouseX - 22.5;
          n3Y = p.mouseY - 18.875;
        }
        if (p.mouseX > n4X && p.mouseX < n4X + 60.75
          && p.mouseY > n4Y && p.mouseY < n4Y + 37.75) {
          n4X = p.mouseX - 30.375;
          n4Y = p.mouseY - 18.875;
        }
        if (p.mouseX > n5X && p.mouseX < n5X + 45
          && p.mouseY > n5Y && p.mouseY < n5Y + 37.75) {
          n5X = p.mouseX - 22.5;
          n5Y = p.mouseY - 18.875;
        }
        if (p.mouseX > n6X && p.mouseX < n6X + 60.75
          && p.mouseY > n6Y && p.mouseY < n6Y + 37.75) {
          n6X = p.mouseX - 30.375;
          n6Y = p.mouseY - 18.875;
        }
      }
    }

    p.windowResized = function windowResized() {
      p.resizeCanvas(p.windowWidth, p.windowHeight);

         nX = p.windowWidth / 10;
   nY = p.windowHeight / 6;

   n2X = p.windowWidth / 10;
   n2Y = (p.windowHeight / 6) + (p.windowHeight / 9);

   n3X = p.windowWidth / 10;
   n3Y = (p.windowHeight / 6) + ((p.windowHeight / 9)*2);

   n4X = p.windowWidth / 10;
   n4Y = (p.windowHeight/ 6) + ((p.windowHeight / 9)*3);

   n5X = p.windowWidth / 10;
   n5Y = (p.windowHeight / 6) + ((p.windowHeight / 9)*4);

   n6X = p.windowWidth / 10;
   n6Y = (p.windowHeight / 6) + ((p.windowHeight / 9)*5);

   exitX = p.windowWidth / 2 - 18.125;
   exitY = p.windowHeight - p.windowHeight / 5;
    };
    }
  });
}

export default App;